import { Container } from "unstated"

import { get } from "lodash"

import api from "./utils/api"
import { toastSuccess, toastError } from "./utils/myToasts"
import deserialize from "./utils/deserialize"
import debounce from "./utils/debounce"

class RPContainer extends Container {
  constructor(props) {
    super(props)

    this.rotateIP = debounce(this.rotateIP)
  }

  meta = {
    fetchingSubsLink: false,
    fetchingSubs: false,
  }

  state = {
    proxiesPageCardSize: "large", // for toggling  proxy card size on proxies page

    // *** for proxies page
    allSubscriptions: [], //array to hold all the subscriptions
    subscriptionsLoaded: false,

    // *** for addaproxy2 checkout page
    manageSubsLink: "",
    selectedCardId: "",
    selectedCardLast4: "",
    selectedCardBrand: "",
  }

  setProxiesPageCardsSizeToLarge = () => {
    this.setState({ proxiesPageCardSize: "large" })
  }

  setProxiesPageCardsSizeToList = () => {
    this.setState({ proxiesPageCardSize: "list" })
  }

  reloadSubscriptions = () => {
    try {
      this.setState({ subscriptionsLoaded: false })
      this.fetchSubscriptions()
    } catch (err) {
      console.error(err)
    }
  }

  getDefaultCardOfSubscription = subscriptionId => {
    const theSub = this.state.allSubscriptions.find(
      elem => elem.id === subscriptionId
    )
    return theSub.card.id
  }

  appendToAllSubscriptions = arr => {
    this.setState(state => {
      return { allSubscriptions: state.allSubscriptions.concat(arr) }
    })
  }

  updateNickOfThisSubscription = (newNick, subscriptionId) => {
    let theSubscr = this.state.allSubscriptions.find(
      elem => elem.id === subscriptionId
    )
    theSubscr.proxyName = newNick
    let idx = this.state.allSubscriptions.indexOf(theSubscr)
    this.setState(state => {
      let allSubscrs = state.allSubscriptions
      allSubscrs.splice(idx, 1, theSubscr)
      return { allSubscriptions: allSubscrs }
    })
  }

  updateOneSubscription = obj => {
    this.setState(state => {
      let allSubscrs = state.allSubscriptions
      let idx = allSubscrs.findIndex(elem => elem.id === obj.id)
      allSubscrs.splice(idx, 1, obj)
      return { allSubscriptions: allSubscrs }
    })
  }

  setSelectedCardId = id => {
    this.setState({ selectedCardId: id })
  }
  setSelectedCardLast4 = val => {
    this.setState({ selectedCardLast4: val })
  }
  setSelectedCardBrand = val => {
    this.setState({ selectedCardBrand: val })
  }

  fetchSubsLink = async (greToken, v2) => {
    if (this.meta.fetchingSubsLink) return

    try {
      this.meta.fetchingSubsLink = true
      const res = await api.get(
        "/subscriptions/manage_subscriptions",
        {},
        {
          params: {
            gre_token: greToken,
            v2,
          },
        }
      )
      const manageSubsLink = get(res, "data.session_id.url")
      this.setState({ manageSubsLink })
    } catch (err) {
      console.error(err)
    }
    this.meta.fetchingSubsLink = false
  }

  fetchSubscriptions = async () => {
    if (this.meta.fetchingSubs) return this.state.allSubscriptions

    try {
      this.meta.fetchingSubs = true
      const res = await api.get("/subscriptions")
      const allSubscriptions = await deserialize(res.data)
      const trailsRes = await api.get("/trials")
      const trials = await deserialize(trailsRes.data)
      const allSubscriptionWithTrials = [
        ...allSubscriptions,
        ...fixTrialsToSub(trials),
      ]
      this.setState({
        allSubscriptions: allSubscriptionWithTrials,
        subscriptionsLoaded: true,
      })
      this.meta.fetchingSubs = false
      return allSubscriptionWithTrials
    } catch (err) {
      this.meta.fetchingSubs = false
      console.error(err)
      return this.state.allSubscriptions
    }
  }

  cancelSubscription = async id => {
    if (
      !window.confirm(
        `Are you sure you want to unsubscribe from this proxy?\n` +
          `After canceling the subscription, the funds for the subscription will be` +
          ` transferred to your credit balance and you can purchase a new proxy.`
      )
    ) {
      return
    }

    try {
      await api.get(`/subscriptions/${id}/cancel`)
      toastSuccess("Canceled successfully!")
      this.fetchSubscriptions()
    } catch (err) {
      console.error(err)
      const message = get(
        err,
        "response.data.errors[0].detail",
        "Some error occured!"
      )
      toastError(message)
      return message
    }
  }

  rotateIP = async ({ id }) => {
    try {
      const res = await api.get(`/modems/${id}/rotate_ip`)
      toastSuccess(res.data.message)
      return this.fetchSubscriptions()
    } catch (err) {
      console.error(err)
      const message = get(
        err,
        "response.data.message",
        get(err, "response.data.errors[0].detail", "Some error occured!")
      )
      toastError(message)
    }
  }

  updateAutoRotationInterval = async (id, autoRotationTime) => {
    try {
      await api.put(`/subscriptions/${id}/auto_ip_rotation_time`, {
        minutes: autoRotationTime,
      })
      toastSuccess("Auto-rotation interval updated!")
      return this.fetchSubscriptions()
    } catch (err) {
      console.error(err)
      const message = get(
        err,
        "response.data.errors[0].detail",
        "Some error occured!"
      )
      toastError(message)
    }
  }

  removeAutoRotationInterval = async id => {
    try {
      await api.delete(`/subscriptions/${id}/auto_ip_rotation_time`)
      toastSuccess("Auto-rotation removed!")
      return this.fetchSubscriptions()
    } catch (err) {
      console.error(err)
      const message = get(
        err,
        "response.data.errors[0].detail",
        "Some error occured!"
      )
      toastError(message)
    }
  }

  updateSubscriptionPaymentMethod = async (
    subscriptionId,
    { name, cardId }
  ) => {
    try {
      const res = await api.put(
        `/subscriptions/${subscriptionId}/update_card`,
        {
          card_id: cardId,
        }
      )
      const subscription = await deserialize(res.data)
      toastSuccess(`${name} set as default for this proxy!`)
      this.updateOneSubscription(subscription)
      return subscription
    } catch (err) {
      console.error(err)
      const message = get(
        err,
        "response.data.errors[0].detail",
        "Some error occured!"
      )
      toastError(message)
    }
  }

  cancelMPManagedSubscription = async id => {
    if (
      !window.confirm(
        `Are you sure you want to cancel your subscription?\n` +
          `If you select Ok, it will not renew on it's renewal date.`
      )
    ) {
      return
    }

    try {
      await api.get(`/subscriptions/${id}/cancel_at_period_end`)
      toastSuccess("Canceled successfully!")
      this.fetchSubscriptions()
    } catch (err) {
      console.error(err)
      const message = get(
        err,
        "response.data.errors[0].detail",
        "Some error occured!"
      )
      toastError(message)
      return message
    }
  }
}

const fixTrialsToSub = trials => {
  return trials.map(trial => ({
    isTrial: true,
    ...trial,
    features: [trial.modem.ipRotation, trial.modem.proxyType],
    card: {},
  }))
}
export const getSubscriptionFeature = (subscription, type) => {
  const features = get(subscription, "features", [])
  const feature =
    Array.isArray(features) &&
    features.find(({ featureType }) => featureType === type)

  return feature || {}
}

export default RPContainer
